import React, { useState, useEffect, useRef } from "react";
import * as XLSX from 'xlsx';
import axios from 'axios';
import { Accordion } from "semantic-ui-react";
import { Icon, Input, Button, Dropdown, Grid, Popup, Segment, Tab, Table, Menu, Form, TextArea, Label, Header, Checkbox } from 'semantic-ui-react'

import Select , { components } from "react-select";
import { render } from "@testing-library/react";
// import Modal from 'react-modal';
import Modal from 'react-bootstrap/Modal';
import './relationship.css';

import {GetJobNames, GetKpiNames, GetSourceNames, SaveProcess1, generateschema, GetAllPages} from '../../../services/process/process_data/process_data'


const identifier2 = [
    { value: "string", label: "string" },
    { value: "int", label: "int" },
    { value: "special charectors", label: "special charectors" },
    { value: "contains", label: "contains" },
    { value: "starts with", label: "starts with" },
    { value: "ends with", label: "ends with" },

];

const identifier1 = [
    { value: "group", label: "group" },
    { value: "sum", label: "sum" },
    { value: "match", label: "match" },


];

const ValueContainer = ({ children, getValue, ...props }) => {
    let maxToShow = 1;
    var length = getValue().length;
    let displayChips = React.Children.toArray(children).slice(0, maxToShow);
    let shouldBadgeShow = length > maxToShow;
    let displayLength = length - maxToShow;
  
    return (
      <components.ValueContainer {...props}>
        {!props.selectProps.inputValue && displayChips}
        <div className="root">
          {/* {shouldBadgeShow &&
            `+ ${displayLength} item${length != 1 ? "s" : ""} selected`} */}
        </div>
      </components.ValueContainer>
    );
  };


const Process = () => {
  const [process_name, setProcessName] = useState('');
  const [process_description, setDescription] = useState('');
  const [process_category, setProcessCategory] = useState({});
  const [selectedSchemas, setSelectedSchemas] = useState('');

  const [jobs, setSelectedJobs] = useState([]);
  const [kpis, setSelectedKpis] = useState([]);
  const [selectedJobs1, setSelectedJobs1] = useState([]);
  const [selectedKpis1, setSelectedKpis1] = useState([]);
  const [sources, setSelectedSources] = useState([]);
  const [selectedSources1, setSelectedSources1] = useState([]);
  const [selectedpages1, setSelectedpages1] = useState([]);
  const [selectedpages, setSelectedpages] = useState([]);

  // Define your options and other variables
  const identifier = []; // Replace with your actual identifier options
  const newValue = ''; // Replace with your initial value
    
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));


  const shouldBeShown = (value) => {
    return value.data.shouldShow;
  };

  const styles = {
    option: (base, value) => {
        return (shouldBeShown(value) ?  { display: 'none'} : { ...base } );
    }
};

  const handleSelectChange = (event, { value }) => {
    console.log('event', event);
    setSelectedSources(event);
  };

  const handleSelectChange1 = (event, { value }) => {
    console.log('event', event);
    setSelectedJobs(event);
  };

  const handleSelectChange2 = (event, { value }) => {
    setSelectedKpis(event);
  };

  const handleSelectChange5 = (event, { value }) => {
    setProcessCategory(event);
  };

  const generate_schema = () =>{
    
    let payload = {
        // 'process_id':'',
        // 'tenants': userCredentials["tenants_id"],
        // 'groups': userCredentials["groups_id"],
        // 'entities': userCredentials["entities_id"],
        'process_name': process_name,
        'sources': sources,
        'schemas': selectedSchemas,
       
        
    }
    console.log('payload', payload)
    var FileUploadCredentials = generateschema();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response!!!", response);
                let data = response.data;
                alert(data.Message)
            }
        )
        .catch((error) => {
            console.error("Error in POST request:", error);
            alert('Generate Schema is getting error!')
          });
  }


  const saveProcess = () =>{

    
    let schemas1 = {
        [process_name] : sources
    }

    let payload = {
        // 'process_id':'',
        // 'tenants': userCredentials["tenants_id"],
        // 'groups': userCredentials["groups_id"],
        // 'entities': userCredentials["entities_id"],
        'process_name': process_name,
        'process_description': process_description,
        'process_category': process_category,
        'sources': sources,
        'schemas': schemas1,
        'jobs': jobs,
        'kpis': kpis
        
    }
    console.log('payload', payload)
    var FileUploadCredentials = SaveProcess1();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response!!!", response);
                alert('Successfully stored process data')
            }
        )
        .catch((error) => {
            console.error("Error in POST request:", error);
            alert('Getting error while storing process data')
          });
  }
  
  const fetchjobnames = () => {


    let payload = {
        'tenants': userCredentials["tenants_id"],
        'groups': userCredentials["groups_id"],
        'entities': userCredentials["entities_id"],
        
    }

    var FileUploadCredentials = GetJobNames();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response!!!", response);
                let table_data = response.data;

                let names = [];
                table_data.map((data) => {

                    let obj = {
                        value: data.job_id,
                        label: data.job_name
                    }
                    names.push(obj);
                })
                setSelectedJobs1(names);
            }
        )
}

const fetchkpinames = () => {


    let payload = {
        'tenants': userCredentials["tenants_id"],
        'groups': userCredentials["groups_id"],
        'entities': userCredentials["entities_id"],
        
    }

    var FileUploadCredentials = GetKpiNames();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response!!!", response);
                let table_data = response.data;

                let names = [];
                table_data.map((data) => {

                    let obj = {
                        value: data.id,
                        label: data.kpi_name
                    }
                    names.push(obj);
                })
                setSelectedKpis1(names);
            }
        )
}

const fetchsourcenames = () => {


    let payload = {
        'tenants': userCredentials["tenants_id"],
        'groups': userCredentials["groups_id"],
        'entities': userCredentials["entities_id"],
        
    }

    var FileUploadCredentials = GetSourceNames();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response!!!", response);
                let table_data = response.data;

                let names = [];
                table_data.map((data) => {

                    let obj = {
                        value: data.source_id,
                        label: data.source_name
                    }
                    names.push(obj);
                })
                setSelectedSources1(names);
            }
        )
}

const handleSelectChange3 = (event, { value }) => {
    setSelectedpages(event);
  };

  const fetchallpagesnames = () => {

    let payload = {
        'tenants': userCredentials["tenants_id"],
        'groups': userCredentials["groups_id"],
        'entities': userCredentials["entities_id"],
        
    }

    var FileUploadCredentials = GetAllPages();

    axios.get(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response pages!!!", response);
                let table_data = response.data;
                table_data = table_data['data_out']
                let names = [];
                if (Array.isArray(table_data)){
                table_data.map((data) => {

                    let obj = {
                        value: data.pages_id,
                        label: data.name,
                        key: data.process_id
                    }
                    names.push(obj);
                })
                }
                setSelectedpages1(names);
            }
        )
}

useEffect(() => {
    fetchjobnames();
    fetchkpinames();
    fetchsourcenames();
    fetchallpagesnames();
}, []);

    return (
        <>
        <Grid item style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
      <div style={{width:'100%'}}>
        <h2 className=" pt-1 pb-1 text-center" style={{ color: "#4969ab"}}>PROCESS</h2>
      </div>
      </Grid>
        <Grid columns='equal' divided style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
            <Grid.Row >
            <Grid.Column>
                    <div className="form-group ">
                        <label className="label1 mb-1" htmlFor={`endPositionInput`}>Process name</label> <br />
                        <Input
                            type="text"
                            style={{width:'100%'}}
                            placeholder="processName"
                            className="resource_input"
                            value={process_name}
                            onChange={(e) => setProcessName(e.target.value)}

                        />
                    </div>
                </Grid.Column>
                <Grid.Column>
                    <div className="form-group ">
                        <label className="label1 mb-1" htmlFor={`endPositionInput`}>Description</label> <br />
                        <Input
                            type="text"
                            style={{width:'100%'}}
                            placeholder="Description"
                            className="resource_input"
                            value={process_description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>
                </Grid.Column>

                <Grid.Column>
                    <div className="form-group ">
                        <label className="label1 mb-1" htmlFor={`endPositionInput`}>Process Category</label> <br />
                        {/* <Input
                            type="text"
                            style={{ width: '8.5em' }}
                            placeholder="End Position"
                            value={processCategory}
                            onChange={(e) => setProcessCategory(e.target.value)}
                        /> */}
                        <Select
                            clearable
                            options={identifier2}
                            selection
                            size='mini'
                            value={process_category}
                            onChange={handleSelectChange5}
                        />
                    </div>
                </Grid.Column>
                <Grid.Column>
                    <div className="form-group ">
                        <label className="label1 mb-1" htmlFor={`startPositionInput`}>Pages</label> <br />
                        <Select
                            clearable
                            options={selectedpages1}
                            selection
                            isMulti
                            size='mini'
                            value={selectedpages}
                            onChange={handleSelectChange3}
                            hideSelectedOptions={false}
                            styles={styles}
                            components={{ ValueContainer }}
                        />
                    </div>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
            <Grid.Column>
                    <div className="form-group ">
                        <label className="label1 mb-1" htmlFor={`startPositionInput`}>Sources</label> <br />
                        <Select
                            clearable
                            options={selectedSources1}
                            selection
                            isMulti
                            size='mini'
                            value={sources}
                            onChange={handleSelectChange}
                            hideSelectedOptions={false}
                            styles={styles}
                            components={{ ValueContainer }}
                        />
                    </div>
                </Grid.Column>
                <Grid.Column>
                    <div className="form-group ">
                        <label className="label1 mb-1" htmlFor={`endPositionInput`}>Schemas</label> <br />
                        <Input
                            type="text"
                            style={{width:'100%'}}
                            placeholder="End Position"
                            className="resource_input"
                            value={selectedSchemas}
                            onChange={(e) => setSelectedSchemas(e.target.value)}
                        />
                    </div>
                </Grid.Column>
                <Grid.Column>
                    <div className="form-group ">
                        <label className="label1 mb-1" htmlFor={`startPositionInput`}>Jobs</label> <br />
                        <Select
                            clearable
                            isMulti
                            options={selectedJobs1}
                            selection
                            size='mini'
                            value={jobs}
                            onChange={handleSelectChange1}
                            hideSelectedOptions={false}
                            styles={styles}
                            components={{ ValueContainer }}

                        />
                    </div>
                </Grid.Column>
                <Grid.Column>
                    <div className="form-group ">
                        <label className="label1 mb-1" htmlFor={`startPositionInput`}>Kpis</label> <br />
                        <Select
                            clearable
                            options={selectedKpis1}
                            selection
                            isMulti
                            size='mini'
                            value={kpis}
                            onChange={handleSelectChange2}
                            hideSelectedOptions={false}
                            styles={styles}
                            components={{ ValueContainer }}

                        />
                    </div>
                </Grid.Column>
            </Grid.Row>

        </Grid>
        <Grid columns='equal' divided style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
        <Grid.Row>
        <Grid.Column>
        {sources && (
            <table id="customers">
                
                {sources.map((option) => (
                    <tr key={option.value}>
                    <th>{option.label}</th>
                    </tr>
                ))}

            </table>
            )}

        </Grid.Column>

        <Grid.Column>
        {sources && (
            <table id="customers">
                
                {sources.map((option) => (
                    <tr key={option.value}>
                    <th>{option.label}</th>
                    </tr>
                ))}

            </table>
            )}
        </Grid.Column>
        
        <Grid.Column>
        {jobs && (
            <table id="customers">
                
                {jobs.map((option) => (
                    <tr key={option.value}>
                    <th>{option.label}</th>
                    </tr>
                ))}

            </table>
            )}
        </Grid.Column>
        <Grid.Column>
        {kpis && (
            <table id="customers">
                
                {kpis.map((option) => (
                    <tr key={option.value}>
                    <th>{option.label}</th>
                    </tr>
                ))}

            </table>
            )}
        </Grid.Column>
        </Grid.Row>
        </Grid>
        <Grid columns='equal' divided style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
            <div className="row">
                <div className="col-md-6 text-center">
                    <button style={{ height: "35px", width: "150px", backgroundColor: "#000055", color: "#ffffff", marginLeft: '2em' }} onClick={generate_schema}>Generate Schema</button>
                </div>
                <div className="col-md-6 text-center">
                    <button style={{ height: "35px", width: "150px", backgroundColor: "#000055", color: "#ffffff", marginLeft: '2em' }} onClick={saveProcess}>Save</button>
                </div>
            </div>
        
        </Grid>
        </>
       )
    }
    
export default Process;